import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const chunkFailed = /Loading chunk [\d]+ failed/;
    if (chunkFailed.test(error?.message)) {
      window.location.reload();
    } else {
      console.error(error);
    }
  }
}
